<template>
  <v-app id="inspire" theme="dark">
    <v-container fluid>
      <v-app-bar>
        <v-row class="justify-center">
          <v-col class="text-center" cols="2">
            <h3 class="nav-link" @click="scrollToTop">Home</h3>
          </v-col>
          <v-col class="text-center" cols="2">
            <h3 class="nav-link" @click="scrollToPmv">PMV</h3>
          </v-col>
          <v-col class="text-center" cols="2">
            <h3 class="nav-link" @click="openSupport">Support Me</h3>
          </v-col>
        </v-row>
      </v-app-bar>
  
      <v-main>
        <div ref="top"></div>
        <v-img :src='require("@/assets/DaisyByteHero.jpg")' cover />
        <v-row style="padding-top: 2em; padding-bottom: 2em;">
          <v-col cols="12" class="text-center">
            <h1>High Quality PMVs At Your Fingertips</h1>
          </v-col>
        </v-row>
        <v-row ref="pmv" class="justify-center">
          <v-col
            cols="3"
            v-for="(thumbnail, index) in thumbnails"
            :key="index"
          >
            <div class="thumbs-item">
              <v-img class="thumbs-img" :src="thumbnail.image" cover />
              <div class="thumbs-overlay">
                <v-btn
                  class="thumbs-btn"
                  size="large"
                  color="pink"
                  @click="openThumbnail(thumbnail.url)"
                >
                  Watch Now
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-main>
    </v-container>
  </v-app>
</template>

<script setup>
</script>

<script>
  export default {
    data: () => ({
      thumbnails: [
        {
          image: require('@/assets/thumbnails/GoodDick.jpg'),
          url: 'https://hypnotube.com/video/hey-there-sissy-daisybytepmv-120967.html'
        },
        {
          image: require('@/assets/thumbnails/ThroatGOAT.jpg'),
          url: 'https://hypnotube.com/video/throat-goat-daiybytepmv-120968.html'
        },
        {
          image: require('@/assets/thumbnails/ActLikeTheGuy.jpg'),
          url: 'https://hypnotube.com/video/act-like-the-guy-daisybytepmv-121035.html'
        },
        {
          image: require('@/assets/thumbnails/Guess.jpg'),
          url: 'https://hypnotube.com/video/guess-daisybytepmv-121036.html'
        },
        {
          image: require('@/assets/thumbnails/KREAM.jpg'),
          url: 'https://hypnotube.com/video/kream-daisybytepmv-120969.html'
        },
        {
          image: require('@/assets/thumbnails/LikeAGirl.jpg'),
          url: 'https://hypnotube.com/video/like-a-girl-daisybytepmv-121037.html'
        },
        {
          image: require('@/assets/thumbnails/SISSY.jpg'),
          url: 'https://hypnotube.com/video/sissy-anthem-daisybytepmv-121312.html'
        },
        {
          image: require('@/assets/thumbnails/EenyWeeny.jpg'),
          url: 'https://hypnotube.com/video/eeny-weeny-daisybytepmv-120970.html'
        },
        {
          image: require('@/assets/thumbnails/Trinkets.jpg'),
          url: 'https://hypnotube.com/video/trinkets-daisybytepmv-121308.html'
        },
        {
          image: require('@/assets/thumbnails/BiggerDickThanYou.jpg'),
          url: 'https://hypnotube.com/video/bigger-dick-daisybytepmv-120972.html'
        },
        // {
        //   image: require('@/assets/thumbnails/GirlsGirl.jpg'),
        //   url: 'https://hypnotube.com/video/censored-boobdrops-for-beta-whiteboys-20556.html'
        // },
        {
          image: require('@/assets/thumbnails/DaddyAF.jpg'),
          url: 'https://hypnotube.com/video/daddy-af-daisybytepmv-121311.html'
        },
        {
          image: require('@/assets/thumbnails/MyType.jpg'),
          url: 'https://hypnotube.com/video/my-type-daisybytepmv-121307.html'
        },
      ],

    }),
    methods: {
      openThumbnail(url) {
        if (!url) return
        window.open(url, '_blank', 'noopener,noreferrer')
      },
      scrollToTop() {
        const el = this.getScrollTarget(this.$refs.top)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      },
      scrollToPmv() {
        const el = this.getScrollTarget(this.$refs.pmv)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      },
      getScrollTarget(target) {
        if (!target) return null
        return target.$el || target
      },
      openSupport() {
        window.open('https://ko-fi.com/daisybyte', '_blank', 'noopener,noreferrer')
      },
    },
  }
</script>

<style scoped>
.nav-link {
  cursor: pointer;
}

.nav-link:hover {
  opacity: 0.85;
}

.thumbs-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.thumbs-img {
  transition: filter 200ms ease;
}

.thumbs-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  opacity: 0;
  transition: opacity 200ms ease;
  pointer-events: none;
}

.thumbs-item:hover .thumbs-img {
  filter: blur(4px);
}

.thumbs-item:hover .thumbs-overlay {
  opacity: 1;
}

.thumbs-btn {
  pointer-events: auto;
}
</style>
